import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class SegmentationBreakdownItemSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    referenceValues: { embedded: 'always' },
  };
}
